import { useCallback } from 'react'
import { getOldestCancellationDate, isAlreadyCanceledOrder, isClosedShiftPlatformOrder, isTicketOrder } from './helper'

export const useCancellationWindow = () => {
	const oldestCancellationTime = getOldestCancellationDate(new Date()).getTime()

	const canCancelOrder = useCallback(order => {
		if (isAlreadyCanceledOrder(order)) return false
		const isInCancellationWindow = new Date(order?.orderDate).getTime() >= oldestCancellationTime
		return isTicketOrder(order) || (isInCancellationWindow && !isClosedShiftPlatformOrder(order))
	}, [oldestCancellationTime])

	return { canCancelOrder }
}
